import { render, staticRenderFns } from "./FeedPostTile.vue?vue&type=template&id=009b6f5d&scoped=true"
import script from "./FeedPostTile.vue?vue&type=script&lang=js"
export * from "./FeedPostTile.vue?vue&type=script&lang=js"
import style0 from "./FeedPostTile.vue?vue&type=style&index=0&id=009b6f5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b6f5d",
  null
  
)

export default component.exports